import React from 'react';
import ExperienceCard from '@/components/ExperienceCard';
import EventCard from '@/components/EventCard';
import { Search } from 'lucide-react';

const DiscoveryGridView = ({ filteredEntities, filteredEvents, activeTab }) => {
  return (
    <>
      {/* Entities Grid */}
      {filteredEntities.length > 0 && activeTab !== 'event' && (
        <section className="mb-12">
          {activeTab === 'all' && (
            <h2 className="text-xl font-semibold mb-6">Guides & Organizations</h2>
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredEntities.map((entity) => (
              <ExperienceCard key={entity.entity_id} entity={entity} />
            ))}
          </div>
        </section>
      )}

      {/* Events Grid */}
      {filteredEvents.length > 0 && (activeTab === 'all' || activeTab === 'event') && (
        <section>
          {activeTab === 'all' && (
            <h2 className="text-xl font-semibold mb-6">Upcoming Events</h2>
          )}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredEvents.map((event) => (
              <EventCard key={event.event_id} event={event} />
            ))}
          </div>
        </section>
      )}

      {/* Empty State */}
      {filteredEntities.length === 0 && filteredEvents.length === 0 && (
        <div className="text-center py-20">
          <Search className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
          <h3 className="text-xl font-semibold mb-2">No results found</h3>
          <p className="text-muted-foreground">
            Try adjusting your search or filters
          </p>
        </div>
      )}
    </>
  );
};

export default DiscoveryGridView;
